import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../services/api';
import { toast } from 'react-toastify';

const PurchasesList = () => {
    const navigate = useNavigate();
    const [purchases, setPurchases] = useState([]);
    const [loading, setLoading] = useState(false);
    const [searchTerm, setSearchTerm] = useState('');

    const formatCurrency = (value) => {
        return new Intl.NumberFormat('pt-PT', { style: 'currency', currency: 'EUR' }).format(value || 0);
    };

    useEffect(() => {
        loadPurchases();
    }, []);

    const loadPurchases = async () => {
        try {
            setLoading(true);
            const res = await api.get('/billing/purchases?pageSize=100');
            setPurchases(res.data?.purchases || []);
        } catch (error) {
            toast.error('Erro ao carregar compras');
            console.error(error);
        } finally {
            setLoading(false);
        }
    };

    const filteredPurchases = purchases.filter(p => 
        !searchTerm || 
        p.invoiceNumber?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        p.supplier?.name?.toLowerCase().includes(searchTerm.toLowerCase())
    );

    return (
        <div style={{ minHeight: '100vh', backgroundColor: 'var(--bg-card)', padding: '2rem' }}>
            {/* Header */}
            <div style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                marginBottom: '2rem',
                padding: '1.5rem',
                backgroundColor: 'white',
                borderRadius: '8px',
                boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
            }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '1rem' }}>
                    <button
                        onClick={() => navigate('/admin/billing')}
                        style={{
                            padding: '0.5rem 1rem',
                            background: 'transparent',
                            border: '1px solid var(--border-color)',
                            borderRadius: '4px',
                            cursor: 'pointer',
                            fontSize: '1.25rem'
                        }}
                    >
                        ← 
                    </button>
                    <h1 style={{ margin: 0, fontSize: '1.5rem', color: 'var(--text-primary)' }}>
                        🛒 Compras - Lançamento Compras
                    </h1>
                </div>
                <div style={{ display: 'flex', gap: '0.5rem' }}>
                    <button
                        onClick={() => navigate('/admin/purchases/new')}
                        style={{
                            padding: '0.75rem 1.5rem',
                            background: 'var(--success)',
                            color: 'white',
                            border: 'none',
                            borderRadius: '6px',
                            cursor: 'pointer',
                            fontSize: '1rem',
                            fontWeight: '600'
                        }}
                    >
                        ➕ Nova Fatura
                    </button>
                </div>
            </div>

            {/* Search and Filter */}
            <div style={{
                padding: '1.5rem',
                backgroundColor: 'white',
                borderRadius: '8px',
                marginBottom: '1rem',
                boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
            }}>
                <div style={{ display: 'flex', gap: '1rem', alignItems: 'center' }}>
                    <div style={{ flex: 1 }}>
                        <label style={{
                            fontSize: '0.75rem',
                            color: 'var(--text-secondary)',
                            fontWeight: '700',
                            display: 'block',
                            marginBottom: '0.25rem',
                            textTransform: 'uppercase'
                        }}>
                            🔍 Pesquisar faturas emitidas
                        </label>
                        <input
                            type="text"
                            placeholder="Nº fatura, fornecedor..."
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                            style={{
                                width: '100%',
                                padding: '0.75rem',
                                border: '2px solid var(--info)',
                                borderRadius: '6px',
                                fontSize: '0.875rem'
                            }}
                        />
                    </div>
                    <button
                        onClick={loadPurchases}
                        style={{
                            marginTop: '1.5rem',
                            padding: '0.75rem 1.5rem',
                            background: 'var(--info)',
                            color: 'white',
                            border: 'none',
                            borderRadius: '6px',
                            cursor: 'pointer',
                            fontSize: '0.875rem',
                            fontWeight: '600'
                        }}
                    >
                        🔄 Atualizar
                    </button>
                </div>
            </div>

            {/* Purchases Table */}
            <div style={{
                backgroundColor: 'white',
                borderRadius: '8px',
                padding: '1.5rem',
                boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
            }}>
                {loading ? (
                    <div style={{ padding: '3rem', textAlign: 'center' }}>
                        <div style={{ fontSize: '2rem' }}>⏳</div>
                        <p>A carregar...</p>
                    </div>
                ) : (
                    <>
                        <div style={{ marginBottom: '1rem' }}>
                            <p style={{ margin: 0, color: 'var(--text-secondary)', fontSize: '0.875rem' }}>
                                {filteredPurchases.length} fatura(s) encontrada(s)
                            </p>
                        </div>
                        <div style={{ overflowX: 'auto' }}>
                            <table style={{ width: '100%', borderCollapse: 'collapse' }} className="adm-table">
                                <thead>
                                    <tr style={{ borderBottom: '2px solid var(--border-color)', background: 'var(--info-bg)' }}>
                                        <th style={{ padding: '12px', textAlign: 'left', fontSize: '0.75rem', fontWeight: '700', color: 'var(--text-secondary)', textTransform: 'uppercase' }}>Nº Fatura</th>
                                        <th style={{ padding: '12px', textAlign: 'left', fontSize: '0.75rem', fontWeight: '700', color: 'var(--text-secondary)', textTransform: 'uppercase' }}>Fornecedor</th>
                                        <th style={{ padding: '12px', textAlign: 'center', fontSize: '0.75rem', fontWeight: '700', color: 'var(--text-secondary)', textTransform: 'uppercase' }}>Data</th>
                                        <th style={{ padding: '12px', textAlign: 'center', fontSize: '0.75rem', fontWeight: '700', color: 'var(--text-secondary)', textTransform: 'uppercase' }}>Estado</th>
                                        <th style={{ padding: '12px', textAlign: 'right', fontSize: '0.75rem', fontWeight: '700', color: 'var(--text-secondary)', textTransform: 'uppercase' }}>Total</th>
                                        <th style={{ padding: '12px', textAlign: 'center', fontSize: '0.75rem', fontWeight: '700', color: 'var(--text-secondary)', textTransform: 'uppercase' }}>Linhas</th>
                                        <th style={{ padding: '12px', textAlign: 'center', fontSize: '0.75rem', fontWeight: '700', color: 'var(--text-secondary)', textTransform: 'uppercase' }}>Ações</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {filteredPurchases.map((purchase) => (
                                        <tr key={purchase.id} style={{ borderBottom: '1px solid var(--border-color)' }}>
                                            <td style={{ padding: '12px' }}>
                                                <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                                                    <button
                                                        onClick={() => navigate(`/admin/purchases/${purchase.id}`)}
                                                        style={{
                                                            background: 'transparent',
                                                            border: 'none',
                                                            color: 'var(--info)',
                                                            cursor: 'pointer',
                                                            fontSize: '1rem',
                                                            padding: 0
                                                        }}
                                                    >
                                                        🔍
                                                    </button>
                                                    <span style={{ fontWeight: '600', fontSize: '0.875rem' }}>
                                                        {purchase.invoiceNumber}
                                                    </span>
                                                </div>
                                            </td>
                                            <td style={{ padding: '12px', fontSize: '0.875rem' }} data-label="Fornecedor">
                                                {purchase.supplier?.name || '-'}
                                            </td>
                                            <td style={{ padding: '12px', textAlign: 'center', fontSize: '0.875rem' }} data-label="Data">
                                                {new Date(purchase.invoiceDate).toLocaleDateString('pt-PT')}
                                            </td>
                                            <td style={{ padding: '12px', textAlign: 'center' }} data-label="Estado">
                                                <span style={{
                                                    padding: '4px 12px',
                                                    borderRadius: '12px',
                                                    fontSize: '0.75rem',
                                                    fontWeight: '600',
                                                    background: purchase.status === 'Paid' ? '#d1fae5' : 
                                                               purchase.status === 'Posted' ? '#fef3c7' : '#f3f4f6',
                                                    color: purchase.status === 'Paid' ? '#065f46' : 
                                                           purchase.status === 'Posted' ? '#92400e' : '#6b7280'
                                                }}>
                                                    {purchase.status === 'Paid' ? 'Pago' : 
                                                     purchase.status === 'Posted' ? 'Lançado' : 'Rascunho'}
                                                </span>
                                            </td>
                                            <td style={{ padding: '12px', textAlign: 'right', fontSize: '0.875rem', fontWeight: '600' }} data-label="Total">
                                                {formatCurrency(purchase.total)}
                                            </td>
                                            <td style={{ padding: '12px', textAlign: 'center', fontSize: '0.875rem' }} data-label="Linhas">
                                                {purchase.lineCount || 0}
                                            </td>
                                            <td style={{ padding: '12px', textAlign: 'center' }} className="adm-actions">
                                                <div style={{ display: 'flex', gap: '0.5rem', justifyContent: 'center' }}>
                                                    <button
                                                        onClick={() => navigate(`/admin/purchases/${purchase.id}`)}
                                                        style={{
                                                            padding: '0.25rem 0.75rem',
                                                            background: 'var(--info)',
                                                            color: 'white',
                                                            border: 'none',
                                                            borderRadius: '4px',
                                                            cursor: 'pointer',
                                                            fontSize: '0.75rem'
                                                        }}
                                                    >
                                                        ✏️ Editar
                                                    </button>
                                                </div>
                                            </td>
                                        </tr>
                                    ))}
                                    {filteredPurchases.length === 0 && (
                                        <tr>
                                            <td colSpan={7} style={{ padding: '3rem', textAlign: 'center', color: 'var(--text-secondary)', fontSize: '0.875rem' }}>
                                                Nenhuma fatura encontrada
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </div>
                    </>
                )}
            </div>
        </div>
    );
};

export default PurchasesList;
